export default __webpack_public_path__ + "static/ProValue_5@768-1202f575ccb1648eab14d1ab7f71c96c.webp";